import {combineReducers, Reducer} from 'redux';

import {INITIALIZE} from './actions';

const initialized: Reducer<boolean> = (state = false, {type}) => (type === INITIALIZE ? true : state);

export default combineReducers({
    initialized,
});
